import { render, staticRenderFns } from "./WorkNotificationMenu.vue?vue&type=template&id=df95e644&scoped=true"
import script from "./WorkNotificationMenu.vue?vue&type=script&lang=js"
export * from "./WorkNotificationMenu.vue?vue&type=script&lang=js"
import style0 from "./WorkNotificationMenu.vue?vue&type=style&index=0&id=df95e644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df95e644",
  null
  
)

export default component.exports